export default function _containsWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_containsWith.js
// module id = /ElO
// module chunks = 0